const mutations = {
  type: 'SET_TYPE',
  class: 'SET_CLASS',
  description: 'SET_DESCRIPTION',
  amount: 'SET_AMOUNT',
  visibility: 'SET_VISIBILITY'
}

/**
 * Set Other list
 * @param {Array} payload - Other Object list.
 */
export const set = ({ commit, dispatch }, payload) => {
  return new Promise((resolve, reject) => {
    if (!Array.isArray(payload)) reject(new Error(`${payload} must be an array`))
    Promise.all([
      new Promise(resolve => resolve(true)),
      payload.map(other => dispatch('addItem', { ...other }))
    ]).then(() => {
      resolve()
    }, (err) => {
      reject(err)
    })
  })
}

/**
 * Add Ohters
 * @param {Object} payload - Other Object.
 */
export const addItem = ({ commit }, payload) => {
  return new Promise((resolve) => {
    commit('ADD', payload)
    resolve()
  })
}

export const removeItem = ({ commit }, key) => {
  return new Promise((resolve) => {
    commit('DELETE', key)
    resolve()
  })
}

/**
 * Update Ohters
 * @param {Object} payload - Other Object.
 */
export const updateItem = ({ commit }, payload) => {
  return new Promise((resolve) => {
    let key = payload.key
    Object().keys(payload).filter(k => k !== 'key')
    .forEach(param => {
      commit(mutations[param], { key, param, value: payload[param] })
    })
    resolve()
  })
}

export const empty = ({ commit, dispatch, state }) => {
  return new Promise((resolve) => {
    if (!state.list.length) resolve()
    Promise.all([
      state.list.map((key) => {
        return dispatch('removeItem', key)
      })
    ]).then(() => {
      resolve()
    })
  })
}
